import React, { Component } from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'

const Wrapper = styled.div`
  position: absolute;
  bottom: 2rem;
  left: 2rem;
  z-index: 2;

  ${media.xs`
    bottom: 1rem;
    left: 1rem;
    transform: scale(0.8);
  `}
`

export default class Icon10 extends Component {
  render() {
    return(
      <Wrapper>
        <svg
          width="93"
          height="87"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#FFF"
            fillRule="evenodd"
            d="M.7421875 23.828125v-3.75c3.0468902 0 5.4296789-.0585932 7.1484375-.1757812 1.7187586-.1171881 3.4960846-.4199195 5.3320312-.9082032 1.8359467-.4882837 3.2421827-1.2109327 4.21875-2.1679687.9765674-.9570361 1.7968717-2.2753823 2.4609376-3.9550781.6640658-1.6796959 1.0742179-3.7499877 1.2304687-6.2109376l.2929687-4.453125H25.9375V85h-4.921875V19.609375c-2.8906395 2.8125141-7.9687137 4.21875-15.234375 4.21875H.7421875zm44.0039063 39.9609375V23.6523438c0-7.2656614 2.3046642-12.8613085 6.9140622-16.7871094C56.269554 2.9394335 61.93356.9765625 68.652344.9765625c6.718783 0 12.382789 1.9433399 16.992187 5.8300781 4.609398 3.8867382 6.914063 9.5019164 6.914063 16.8457032v40.1367187c0 7.3437867-2.304665 12.95896494-6.914063 16.84570312-4.609398 3.88673819-10.273404 5.83007813-16.992187 5.83007813-6.718784 0-12.38279-1.962871-16.992188-5.88867187-4.609398-3.92580088-6.9140622-9.52144808-6.9140622-16.78710938zM49.667969 64.375c0 5.4297146 1.845684 9.7656088 5.537109 13.0078125 3.691425 3.24220371 8.173802 4.86328125 13.447266 4.86328125 5.664091 0 10.244123-1.75779492 13.740234-5.2734375 3.496111-3.51564255 5.244141-8.39840625 5.244141-14.64843745V25.234375c0-6.4844074-1.767561-11.4452953-5.302735-14.8828125-3.535174-3.4375172-8.095675-5.15625-13.68164-5.15625-5.585966 0-10.146467 1.6992018-13.681641 5.0976563-3.535174 3.3984544-5.302734 8.3398113-5.302734 14.8242187V64.375z"
          />
        </svg>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Grades/Icon10.js